import { AxiosRequestConfig, AxiosResponse } from 'axios';
import api from '.';

abstract class ApiService {
  protected constructor(resource: string) {
    this.resource = '/api/v1' + resource;
  }

  resource: string;

  async post<T>(url: string, payload = {}): Promise<T> {
    return await api.post(this.resource + url, payload);
  }

  async get<T>(
    url: string,
    config: AxiosRequestConfig = {},
  ): Promise<AxiosResponse<T>> {
    return await api.get(this.resource + url, config);
  }

  async put<T>(url: string, payload = {}): Promise<AxiosResponse<T>> {
    return await api.put(this.resource + url, payload);
  }

  async delete<T>(url: string, payload = {}): Promise<AxiosResponse<T>> {
    return await api.delete(this.resource + url, payload);
  }

  async patch<T>(url: string, payload = {}): Promise<AxiosResponse<T>> {
    return await api.patch(this.resource + url, payload);
  }
}

export default ApiService;
